import React, { useEffect, useRef } from 'react';
import './ParallaxImageBand.css';

/* local image – nothing to pass down from App.js */
import ParallaxImage from '../Assets/OtherImages/ParallaxImage.jpg';

/**
 * text  – headline shown in the centre
 * speed – 0 … 1  (0 = fixed, 1 = normal scroll; 0.2 → image moves 0.8× page speed)
 */
export default function ParallaxImageBand({
    text = 'EVERY STEP COUNTS',
    speed = 0.6
}) {
    const bandRef = useRef(null);   // add this
    const imgRef = useRef(null);

    /* tiny, throttled scroll listener to create translateY parallax */
    useEffect(() => {
        let rafId = 0;

        const onScroll = () => {
            if (rafId) return;
            rafId = requestAnimationFrame(() => {
                if (!bandRef.current || !imgRef.current) { rafId = 0; return; }

                const bandRect = bandRef.current.getBoundingClientRect();
                const viewportH = window.innerHeight;

                /* progress: 0 when band enters, 1 when it leaves viewport */
                const progress = 1 - (bandRect.bottom / (viewportH + bandRect.height));
                /* clamp 0-1 so it stops translating once out of view */
                const clamped = Math.max(0, Math.min(1, progress));

                const offset = clamped * bandRect.height * speed;
                imgRef.current.style.transform = `translateY(${offset}px)`;
                rafId = 0;
            });
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        /* run once in case the band is already in view on load */
        onScroll();
        return () => {
            window.removeEventListener('scroll', onScroll);
            cancelAnimationFrame(rafId);
        };
    }, [speed]);

    return (
        <section className="parallax-band" ref={bandRef}>
            <img
                ref={imgRef}
                src={ParallaxImage}
                alt="Runners on the road"
                className="parallax-band__img"
            />
            <h2 className="parallax-band__headline">{text}</h2>
        </section>
    );
}
